import assistantStore from '@stores/assistantStore'
import { Drawer, Grid } from 'antd'
import { observer } from 'mobx-react'

import AssistantPanel from './AssistantPanel'

const AssistantDrawer = () => {
  // Full width below the md breakpoint (tablets/phones); 600px side panel otherwise.
  const screens = Grid.useBreakpoint()

  return (
    <Drawer
      placement="right"
      width={screens.md === false ? '100%' : 600}
      mask={false}
      closable={false}
      open={assistantStore.isOpen}
      onClose={assistantStore.close}
      styles={{
        header: { display: 'none' },
        body: { padding: 0, display: 'flex', flexDirection: 'column' },
      }}
    >
      <AssistantPanel />
    </Drawer>
  )
}

export default observer(AssistantDrawer)
